import { Text } from '@chakra-ui/react';
import RoutableModal from 'components/general/RoutableModal';
import { useLocationUpdateMutation } from 'generated/graphql';
import { FormProvider } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import LocationForm from '../LocationForm';
import { useEditLocationForm } from './lib';

function EditLocation() {
  const { locationId: id } = useParams() as { locationId: string };
  const [location, form] = useEditLocationForm();
  const navigate = useNavigate();
  const goBack = () => navigate('..');
  const [updateLocation, { loading }] = useLocationUpdateMutation({
    onCompleted: goBack,
  });

  const handleSubmit = form.handleSubmit(data => {
    updateLocation({ variables: { id, data } });
  });

  if (location.loading) return null;

  return (
    <RoutableModal
      title="Edit Location"
      buttons={{ action: { text: 'Save', handler: handleSubmit } }}
      loading={loading}
    >
      <Text mb={10}>Please enter the required information to update this location</Text>
      <FormProvider {...form}>
        <LocationForm />
      </FormProvider>
    </RoutableModal>
  );
}

export default EditLocation;
